export const FETCH_PROFILEUSER_BEGIN = "FETCH_PROFILEUSER_BEGIN";
export const FETCH_PROFILEUSER_SUCCESS = "FETCH_PROFILEUSER_SUCCESS";
export const FETCH_PROFILEUSER_FAILURE = "FETCH_PROFILEUSER_FAILURE";

